import classNames from 'classnames/bind'
import { Link } from 'react-router-dom'
import './styles.scss'

export function ListHeader ({ children, url, active, className, onClick }) {
  const classes = {
    'collection-header': true,
    active
  }

  if (className) {
    classes[className] = true
  }

  const itemClasses = classNames(classes)

  return url
    ? (
      <Link
        className={itemClasses}
        to={url}
        data-test='list-header-link'
      >
        <h2>{children}</h2>
      </Link>
    )
    : (
      <button
        className={itemClasses}
        data-test='list-header-nolink'
        onClick={onClick}
      >
        <h2>{children}</h2>
      </button>
    )
}

export function ListItem ({ children, url, active, className = null }) {
  const classes = {
    'collection-item': true,
    active
  }

  if (className) {
    classes[className] = true
  }
  const itemClasses = classNames(classes)

  // <a className={itemClasses} href={url}>{children}</a>
  if (url) {
    return (
      <Link
        className={itemClasses}
        to={url}
        data-test={active ? 'highlighted-list-item' : 'list-item-link'}
      >
        {children}
      </Link>
    )
  }
  return (
    <div
      className={itemClasses}
      data-test={active ? 'highlighted-list-item' : 'list-item-nolink'}
    >
      {children}
    </div>
  )
}

export function List ({ children, className = null }) {
  const classes = [ 'collection', 'with-header', className ]
    .filter(c => c)
    .join(' ')
  return (
    <div
      className={classes}
      data-test='list'
    >
      {children}
    </div>
  )
}
